import { Map } from 'immutable'
import { Locale } from '../../drupal/types_and_parser/extra_types.mod'

export const allLanguages: Array<Locale> = [
  'de',
  'es',
  'fr',
  'it',
  'fi',
  'nl',
  'na',
  'uk',
  'us',
  'global',
  'be_nl',
  'be_fr',
  'na-fr',
  'na-es',
  'pl',
  'au'
]

export const defaultLanguage: Locale = 'en'

export const oldSites: Map<Locale, string> = Map<Locale, string>(window.allSites)

export const localeTranslations = Map<Locale, string>({
  global: 'Global — English',
  de: 'Deutschland',
  es: 'España',
  fr: 'France',
  it: 'Italia',
  fi: 'Finland',
  be_nl: 'Nederlands — België',
  be_fr: 'Nederlands — Francais',
  'na-fr': 'North America — Francais',
  'na-es': 'North America — Spanish',
  nl: 'Nederland',
  uk: 'United Kingdom',
  us: 'United States',
  pl: 'Poland',
  au: 'Australia'
})

export const localeISOcodes = Map<Locale, string>({
  global: 'x-default',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  fi: 'fi-FI',
  nl: 'nl-NL',
  uk: 'en-GB',
  us: 'en-US',
  pl: 'PL',
  au: 'en-au'
})

export const addLangToUrl = (url: string): string => {
  const language = getLangFromUrl()
  return `/${language}${url}`
}

/*
 * All Drupal URLs will be prefixed with a Language code
 * This code must be replace by the current Region or Locale code
 */
export const updateUrlLang = (url: string, newLang: string): string => {
  if (url?.startsWith('/')) {
    url = url.slice(1)
  }
  const path = url.split('/').slice(1).join('/')

  // If the requested language is the default language, we'll leave the url untouched
  return `/${newLang}/${path}`
}

export const getLangFromUrl: () => Locale = () => {
  let lang: Locale = defaultLanguage
  if (window.location.pathname != '/') {
    const pathSplit = window.location.pathname.split('/')
    if (pathSplit.length > 1) {
      lang = pathSplit[1] as Locale
    }
  }

  // Fix for previews on www.refresco.es
  if (lang == ('ib' as Locale)) return 'es'

  return allLanguages.includes(lang) ? lang : defaultLanguage
}

//example of url: en/xyz
//not good url: /en/xyz
export const removeLangFromUrl = (url: string) => {
  let url1 = url
  if (url != '/') {
    const pathSplit = url.split('/')
    if (pathSplit.length > 1) {
      url1 = pathSplit.splice(1).join('/')
    }
  }
  return url1
}

export const getLangFromHost = (): Locale => {
  return (
    oldSites
      .filter((v, k) => window.location.toString().startsWith(v))
      .map((v, k) => k)
      .first() || defaultLanguage
  )
}
